import styled from '@emotion/styled';
import { Button } from 'react-magma-dom';
import { BANNER_HEIGHT, COLORED_LINE_HEIGHT, COLORS, FOOTER_HEIGHT, HEADER_HEIGHT } from '../../constants';

const imageShift = 78;

export const StyledNotFoundWrapper = styled.div<{ withBanner?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(
    100vh -
      ${({ withBanner }) => HEADER_HEIGHT + COLORED_LINE_HEIGHT + FOOTER_HEIGHT + (withBanner ? BANNER_HEIGHT : 0)}px
  );
  overflow-y: scroll;
`;

export const StyledNotFoundContent = styled.div`
  max-width: 339px;
  margin-bottom: 120px;
  margin-left: ${imageShift}px;
  color: ${COLORS.blackOlive};
`;

export const StyledNotFoundImg = styled.img`
  height: 490px;
  position: relative;
  left: -${imageShift}px;
  z-index: -1;
`;

export const StyledNotFoundHeading = styled.h1`
  font-size: 96px;
  font-weight: 600;
  margin: 0;
`;

export const StyledNotFoundText = styled.p`
  margin: 15px 0 40px 0;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.54;
`;

export const StyledNotFoundBtn = styled(Button)`
  height: 42px;
  border-radius: 8px;
`;
